export default function (menuItems) {
  if (!menuItems) {
    return null
  }
  if (menuItems[0]?.destination === '/') {
    return 'dashboard'
  }
  return menuItems[0]?.destination?.replace('/', '-') ?? null
}
